<template>
  <LayoutBaseContent class="max-w-7xl pb-8">
    <div class="flex items-center ml-2 mt-2 sm:mt-0">
      <h1 class="font-medium text-3xl leading-snug">Blog & podcasts</h1>

      <p v-if="$route.params.categorySlug" class="text-gray-darker font-medium ml-2 capitalize">
        Category {{ $route.params.categorySlug }}
      </p>
      <p v-if="compCurrentPageNumber > 1" class="text-gray-darker ml-2">Page {{ compCurrentPageNumber }}</p>
    </div>

    <div v-if="compPosts.length === 0" class="flex flex-wrap justify-between mt-4">
      <div v-for="i in 9" :key="i" class="sm:px-2 w-full sm:w-6/12 md:w-4/12 mb-8 sm:mb-4">
        <UtilPlaceholder class="w-full sm:rounded-t" style="height: 223px;" />

        <div class="bg-white pt-2 pb-2 sm:rounded-b px-4">
          <UtilPlaceholder class="h-6" />

          <UtilPlaceholder class="h-2 mt-4" />
          <UtilPlaceholder class="h-2 w-8/12 mt-2" />
          <UtilPlaceholder class="h-2 w-10/12 mt-2" />

          <UtilPlaceholder class="h-2 w-5/12 mt-6" />
        </div>
      </div>
    </div>

    <template v-else>
      <div class="flex flex-wrap justify-between mt-4">
        <UtilBlogPostCard v-for="post in compPosts" :key="post.fields.slug" :post="post" :bgWhite="true" />
      </div>

      <UtilDivider class="mx-2 my-4" />

      <div class="flex flex-wrap sm:flex-no-wrap items-center justify-between px-2">
        <p class="order-2 sm:order-1 mt-8 sm:mt-0 text-center sm:text-left w-full sm:w-auto">
          Showing
          <span class="font-medium">
            {{ this.compCurrentPageNumber * this.totalPostsPerPage - this.totalPostsPerPage + 1 }}
          </span>
          to
          <span class="font-medium">{{ compShowingTo }}</span>
          of
          <span class="font-medium">{{ compTotalResults }}</span>
          results
        </p>

        <div class="flex items-center w-full sm:w-auto justify-between order-1 sm:order-2">
          <UtilButton
            v-if="compCurrentPageNumber > 1"
            :to="`?page=${compCurrentPageNumber - 1}`"
            color="secondary"
            class="mr-0 sm:mr-4 w-5/12 sm:w-auto"
          >
            Previous
          </UtilButton>

          <UtilButton
            v-if="compShowingTo < compTotalResults"
            :to="`?page=${compCurrentPageNumber + 1}`"
            color="primary"
            class="w-5/12 sm:w-auto"
          >
            Next
          </UtilButton>
        </div>
      </div>
    </template>
  </LayoutBaseContent>
</template>

<script>
import { generateMetaTags } from '@/lib/generate-meta'
import { contentfulBlogClient } from '@/lib/api/contentful'
import LayoutBaseContent from '@/components/layout/LayoutBaseContent'
import UtilButton from '@/components/utils/UtilButton'
import UtilDivider from '@/components/utils/UtilDivider'
import UtilBlogPostCard from '@/components/utils/UtilBlogPostCard'
import UtilPlaceholder from '@/components/utils/placeholders/UtilPlaceholder'

export default {
  name: 'Blog',
  components: {
    LayoutBaseContent,
    UtilBlogPostCard,
    UtilButton,
    UtilDivider,
    UtilPlaceholder
  },
  data() {
    return {
      totalPostsPerPage: 9,
      postListClient: null
    }
  },
  watch: {
    '$route.query'() {
      this.getPosts()
      this.$scroll.toTop()
    },

    '$route.path'() {
      this.getPosts()
      this.$scroll.toTop()
    }
  },
  created() {
    this.getPosts()
  },
  computed: {
    compPosts() {
      return this.postListClient ? this.postListClient.items : []
    },

    compTotalResults() {
      return this.postListClient.total
    },

    compCurrentPageNumber() {
      return parseInt(this.$route.query.page) || 1
    },

    compShowingTo() {
      let showingTo = this.totalPostsPerPage * this.compCurrentPageNumber

      if (showingTo > this.compTotalResults) {
        return this.compTotalResults
      }

      return showingTo
    }
  },
  methods: {
    async getPosts() {
      let blogFilterParams = {
        content_type: 'post',
        order: '-fields.created_at',
        skip: this.compCurrentPageNumber * this.totalPostsPerPage - this.totalPostsPerPage,
        limit: this.totalPostsPerPage
      }

      if (this.$route.params.categorySlug) {
        blogFilterParams['fields.category[en]'] = this.$route.params.categorySlug
      }

      this.postListClient = await contentfulBlogClient.getEntries(blogFilterParams)
    }
  },
  head: {
    title() {
      return {
        inner: 'Blog'
      }
    },
    meta() {
      return generateMetaTags()
    }
  }
}
</script>
